import React, { useContext, useState } from 'react';

import { Delete } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ClearAllConfirmModal from './ClearAllConfirmModal';
import { WhiteboardContext } from '../../../context/WhiteboardContext';
import { SessionTypes } from '../../../types';
import { UserRoles } from '../../../../roster/types';
import { WhiteboardSessionContext } from '../../../context/WhiteboardSessionContext';

type Props = {
    onDeleteAllConfirm: () => void;
};

const ClearAllButton = React.memo((props: Props) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const { t } = useTranslation('whiteboard');

    const { userInfo } = useContext(WhiteboardContext);
    const { whiteboardSessionState } = useContext(WhiteboardSessionContext);

    if (
        whiteboardSessionState.session?.type === SessionTypes.Shared
        && userInfo?.role === UserRoles.Student
    ) {
        return null;
    }

    return (
        <>
            <Button
                style={{ minWidth: 0, padding: '0.45rem', margin: '1.5px' }}
                variant="contained"
                color="inherit"
                disableElevation
                title={t('clearAll')}
                onClick={() => setDialogOpen(!dialogOpen)}
            >
                <Delete sx={{ fill: '#666' }}/> {t('clearAll')}
            </Button>
            <ClearAllConfirmModal
                open={dialogOpen}
                onClose={() => setDialogOpen(!dialogOpen)}
                onConfirm={() => {
                    setDialogOpen(!dialogOpen);
                    props.onDeleteAllConfirm();
                }}/>
        </>
    );
});

export default ClearAllButton;
